import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Link } from "react-router-dom";

import * as ActionTypes from '../actions';
import Alert from '../components/Alert';
import Button from '../components/Button';
import Form from '../components/Form';
import Heading from '../components/Heading';
import Input from '../components/Input';
import LoadingSpinner from '../components/LoadingSpinner';
import Pagination from '../components/Pagination';
import PaginationPrev from '../components/PaginationPrev';
import PaginationNext from '../components/PaginationNext';

import CartItemEditable from './CartItemEditable';

const mapStateToProps = (state) => {
    return {
        items: state.items,
        data: state.data,
        forms: state.forms,
        isLoading: state.isLoading
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addItem: (identifier) => dispatch(ActionTypes.addItem(identifier))
    };
};

class Cart extends Component {

    handleAddItem = event => {
        event.preventDefault();

        if (this.identifierInput.value) {
            this.props.addItem(this.identifierInput.value);
        }
    }

    render() {
        const {items, data, forms, isLoading} = this.props;

        let isCheckoutPossible = true;

        if (items.length == 0) {
            isCheckoutPossible = false;
        }

        Object.values(items).forEach(function(item) {
            if (item.participants.length == 0) {
                isCheckoutPossible = false;
            }
        });

        let totalPrice = 0;
        Object.values(items).forEach(function(item) {
            if (item.properties.totalPrice) {
                totalPrice += item.properties.totalPrice * Object.keys(item.participants).length;
            }
        });

        if (totalPrice) {
            totalPrice = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(totalPrice);
        }

        return (
            <div>
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div>
                        <Heading>Veranstaltungen und Teilnehmer</Heading>

                        {items && Object.entries(items).map(([key, value]) => (
                            <CartItemEditable key={key} item={value} />
                        ))}

                        { ! isCheckoutPossible && (
                            <div>
                                {items.length == 0 ? (
                                    <Alert theme="primary">Bitte fügen Sie eine Veranstaltung hinzu.</Alert>
                                ) : (
                                    <Alert theme="primary">Bitte fügen Sie Teilnehmer zu jeder Veranstaltung hinzu.</Alert>
                                )}
                            </div>
                        )}

                        <p class="mb-3 text-right">
                            Preis: <strong>{totalPrice}</strong>
                        </p>

                        <Pagination>
                            <PaginationNext>
                                {isCheckoutPossible ? (
                                    <Link to="/checkout" className="btn btn-primary">Zur Anmeldung</Link>
                                ) : (
                                    <Button type="button" disabled="true">Zur Anmeldung</Button>
                                )}
                            </PaginationNext>
                        </Pagination>
                    </div>
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
